import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import {
  Theme,
  createStyles,
  withStyles,
  WithStyles
} from '@material-ui/core/styles'
import DialogContentText from '@material-ui/core/DialogContentText'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../OneplaceLibraryProvider'

const styles = (_theme: Theme) =>
  createStyles({
    root: {}
  })

export type SubmitDialogStage =
  | 'submitting'
  | 'submit_successful'
  | 'submit_error'

export interface ISubmitStatusDialogProps
  extends WithStyles<typeof styles>,
    IOneplaceLibraryContextProp {
  isOpen: boolean
  title: string
  stage: SubmitDialogStage
  message?: string
  subMessage?: string | React.ReactElement<any>
  showContinueButtons?: boolean
  onClose: () => void
  onContinueEditing?: () => void
  onGoToDashboard?: () => void
  dismissDisabled?: boolean
  onSubmit?: () => void
  customButtonAction?: () => void
  customButtonActionLabel?: string
}

const SubmitStatusDialog = withStyles(styles)(
  withOneplaceLibraryContext((props: ISubmitStatusDialogProps) => {
    const t = props.ctx.i18next.t
    const dismissDisabled =
      props.stage == 'submitting' || !!props.dismissDisabled

    return (
      <Dialog
        open={props.isOpen}
        onClose={props.onClose}
        disableBackdropClick={dismissDisabled}
        disableEscapeKeyDown={dismissDisabled}
      >
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
          {props.stage == 'submitting' && (
            <div style={{ display: 'flex', marginTop: 10 }}>
              <CircularProgress size={32} />
              <Typography
                style={{ fontSize: 16, marginTop: 6, marginLeft: 16 }}
              >
                {t('submitting')}
              </Typography>
            </div>
          )}
          {props.stage != 'submitting' && (
            <div>
              <DialogContentText>{props.message}</DialogContentText>
              {props.subMessage && (
                <Typography style={{ marginTop: 16 }} component='div'>
                  {props.subMessage}
                </Typography>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          {props.stage == 'submit_error' && (
            <>
              <Button
                onClick={props.onSubmit}
                color='primary'
                aria-label={t('retry_submission')}
              >
                {t('retry_submission')}
              </Button>
              <Button
                onClick={props.onClose}
                color='primary'
                aria-label={t('continue_editing')}
              >
                {t('continue_editing')}
              </Button>
              {props.customButtonAction ? (
                <Button
                  onClick={props.customButtonAction}
                  color='primary'
                  aria-label='custom'
                >
                  {props.customButtonActionLabel ||
                    'Custom action button label'}
                </Button>
              ) : (
                <Button
                  onClick={props.onGoToDashboard}
                  color='primary'
                  aria-label={t('go_to_dashboard')}
                >
                  {t('go_to_dashboard')}
                </Button>
              )}
            </>
          )}
          {props.stage == 'submit_successful' && !props.showContinueButtons && (
            <Button
              onClick={props.onClose}
              color='primary'
              aria-label={t('ok')}
            >
              {t('ok')}
            </Button>
          )}
          {props.stage == 'submit_successful' && props.showContinueButtons && (
            <>
              <Button
                onClick={props.onContinueEditing}
                color='primary'
                aria-label={t('continue_editing')}
              >
                {t('continue_editing')}
              </Button>
              <Button
                onClick={props.onGoToDashboard}
                color='primary'
                aria-label={t('exit')}
              >
                {t('exit')}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    )
  })
)

export default SubmitStatusDialog
